const TABLE_DEFAULT = 'table0';

const TABLES = [
    {value: 'table0', label: 'Table 1'},
    {value: 'table1', label: 'Table 2'}
];

var _ = require('lodash');

module.exports = {
    getDefaultTable: () => TABLE_DEFAULT,
    getTables: () => TABLES,

    getCurveSets: (config) => {
        // convert curves list to curve_map & create curve_sets
        let curve_map = {};
        if (typeof config.curve_sets == 'undefined' && !_.isEmpty(config.curves)) {
            _.map(config.curves, (curve) => curve_map[curve] = '');

            config = {
                ...config,
                curve_sets: {
                    table0: {curve_map},
                    table1: {curve_map},
                }
            };
        }

        return config;
    },

    removeCurves: (config) => {
        // remove curves prop if exist
        if (config.curves) delete config.curves;
    },

    updateWells: (config) => {
        // set well event_type
        config = {
            ...config,
            wells: _.map(config.wells, (well) => {
                return ({
                    event_type: well.event_type,
                    include_extra: true,
                    curve_set: well.curve_set || TABLE_DEFAULT
                });
            }),
        };

        return config;
    }
};
